import { IDropDownOptions } from "../Component/Common/Components/FormValidationInputs/AppRadioButtons";

export const copyArray = <T>(array: Array<T>): Array<T> => {
    return JSON.parse(JSON.stringify(array));
}

export function getIOptionsArray<T extends Record<K, number | string>, K extends keyof T>(
    data: T[],
    idProp: K,
    nameProp: K
): IDropDownOptions[] {
    if (data === null || data === undefined) return [];
    return data.map((item: T) => {
        const id = item[idProp] as number;
        const value = item[nameProp] as string;
        return { id: id, value: value };
    });
}

export const commaSeparateArray = (array: string[]): string => {
    return array.join(', ');
}